module.exports = __webpack_public_path__ + "img/game-features-events.4dc04cf1.png";